import React from 'react';
import { Row, Col } from 'react-bootstrap';

import IntlDateTime from 'components/layout/IntlDateTime';

class Default extends React.Component {
  render() {
    const { appt } = this.props;

    return (
      <div>
        <div className="event-inner">
          <div className="event-title">{appt.name}</div>
          {!appt.takes_full_day && (
            <div className="time-wrap">
              <span className="event-start-time">
                <IntlDateTime date={appt.date_from} />
              </span>
              {' - '}
              <span className="event-end-time">
                <IntlDateTime date={appt.date_to} />
              </span>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Default;
